import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import styles from "./NewChecklistItem.module.css";

type ChecklistItemProps = {
  title: string;
  onDelete: () => void;
};

function NewChecklistItem({ title, onDelete }: ChecklistItemProps) {
  return (
    <div className={styles["root"]}>
      <div className={styles["checkbox"]} />
      <FixaText className={styles["text"]!} textStyle="Body.S">
        {title}
      </FixaText>
      <FixaButton
        ssrIcon={TrashCanIconPath}
        iconOnly
        type="tertiary"
        size="xsmall"
        onClick={onDelete}
      />
    </div>
  );
}

export default NewChecklistItem;
